import { loadCurrentProfile } from 'src/api/concerns/profiles_headers'
import { AlterRequest } from 'src/api/middleware/interfaces'
import { getStore } from 'src/store/store-holder'

const alterRequest: AlterRequest = async (request: Request) => loadCurrentProfile(request, getStore())

export default {
  alterRequest
}
